import { IView } from'../../../pip/library/pi-interop/pi-interop.js';

import { ITenant } from 'src/modules/product_module';
import { Hosting } from 'src/core/ahp';

export class PrimaryMenuViewRC implements IView {
  id = 'primary-menu';
  ns = 'ahp';

  region: HTMLElement;
  tenant: ITenant;

  constructor(public ahp: Hosting) {}

  mount(region: HTMLElement) {
    const navEl = document.createElement('hi-navigation-primary');
    navEl.title = this.ahp.product.configuration.tenant.title;

    region.appendChild(navEl);
    return Promise.resolve(this);
  }
}
